import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  searchQuery: '',
  mcc: {},
  type: '',
};

const mccListValue = createSlice({
  name: 'mccValue',
  initialState,
  reducers: {
    setMccPayLoadValue: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setMcclistValue: (state, action) => {
      return {...state, ...action.payload};
    },
    resetMccValue: () => initialState,
  },
});

export const {setMccPayLoadValue, setMcclistValue, resetMccValue} =
  mccListValue.actions;

export default mccListValue.reducer;
